import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import VwKimlikDTO from "src/models/Genel/VwKimlikDTO";
import { GridState } from "src/models/GridState";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import kimlikService from "src/services/Genel/kimlik.service";
import { kimlikApi } from "src/services/Genel/KimlikApi";

export const getByKimlikId = createAsyncThunk(
    'kimlikService/getByKimlikId',
    async (kimlikId: number, thunkAPI) => {
        const response = await kimlikService.getByKimlikId(kimlikId);
        return response
    }
)
export const getDetayliArama = createAsyncThunk(
    'kimlikService/getDetayliArama',
    async (aramaModel: VwKimlikDTO, thunkAPI) => {
        const response = await kimlikService.getDetayliArama(aramaModel);
        return response
    }
)
export interface IKimlikState extends GridState<VwKimlikDTO> {
    aramaKriterleri: VwKimlikDTO;
    aramaTiklandi: boolean;
    borcVar: boolean;
    cancelPathName?: string;
    yeniKayit?: boolean;
    kayitliKimliklerOpen?: boolean;
    kayitliKimlikler?: Array<VwKimlikDTO>;
    kurumDisi?: string;
    editMode?: boolean;
    updateAllFields?: boolean;
}

const KimlikSlice = createSlice<IKimlikState, MapReducerPayloads<IKimlikState, {
    setState: IKimlikState,
    clearActiveRow: void,
    setActiveRow: VwKimlikDTO,
    setBorcVar: boolean,
    setCancelPathname: string,
    setYeniKayit: boolean,
    setKurumDisi: string,
    setEditMode: boolean,
    setUpdateAllFields: boolean,

}>>({
    name: 'KimlikState',
    initialState: {
        data: [],
        activeRow: new VwKimlikDTO(),
        aramaKriterleri: new VwKimlikDTO(),
        aramaTiklandi: false,
        borcVar: false,
        yeniKayit: false,
        kayitliKimliklerOpen: false,
        kayitliKimlikler: [],
        kurumDisi: "H",
        editMode: false,
        updateAllFields: false,
    },
    reducers: {
        setState: (state, action) => action.payload,
        clearActiveRow: (state, action) => {
            state.activeRow = new VwKimlikDTO()
        },
        setActiveRow: (state, action) => {
            state.activeRow = action.payload
            return state;
        },
        setBorcVar: (state, action) => {
            state.borcVar = action.payload
        },
        setCancelPathname: (state, action) => {
            state.cancelPathName = action.payload
        },
        setYeniKayit: (state, action) => {
            state.yeniKayit = action.payload
        },
        setKurumDisi: (state, action) => {
            state.kurumDisi = action.payload
        },
        setEditMode: (state, action) => {
            state.editMode = action.payload
        },
        setUpdateAllFields: (state, action) => {
            state.updateAllFields = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getByKimlikId.pending, (state, { payload }) => {
            state.isLoading = true
        })
        builder.addCase(getByKimlikId.fulfilled, (state, action) => {
            return {
                ...state,
                activeRow: action.payload.data,
                errorMessage: action.payload.errorMessage,
                isLoading: false
            }
        })
        builder.addCase(getDetayliArama.pending, (state, { payload }) => {
            state.isLoading = true
        })
        builder.addCase(getDetayliArama.fulfilled, (state, action) => {
            return {
                ...state,
                data: action.payload.data || [],
                errorMessage: action.payload.errorMessage,
                isLoading: false,
                isFetching: false,
                aramaTiklandi: false
            }
        })
        builder.addMatcher(kimlikApi.endpoints.getByKimlikId.matchFulfilled, (state, action) => {
            state.activeRow = action.payload
        })
    }
})
export default KimlikSlice;